export const MODAL_TYPE_VACATIONS = {
  QUICKLOOK: "quickLook",
  ATTACHMENTS: "attacments",
  VALIDATE: "validate"
};



// WEBPACK FOOTER //
// src/modules/presence/utils/constants.js